import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RoleId } from './role';

export type Apps =
  | 'manage'
  | 'share'
  | 'clock'
  | 'calendar'
  | 'videos'
  | 'contentpackages';
export interface Access {
  role: RoleId;
  enabled: boolean;
}

export type AppAccess = Record<Apps, Access>;

export function isApps(data?: any): data is Apps {
  if (typeof data !== 'string') return false;
  switch (data) {
    case 'manage':
    case 'share':
    case 'clock':
    case 'calendar':
    case 'contentpackages':
    case 'videos':
      return true;
    default:
      return false;
  }
}

export interface Navigation {
  title: string;
  path: string;

  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;

  /**
   * Called to determine if the user has access to the page. Will be
   * passed the highest role for the app in the `role` prop. Up to the
   * app to return a boolean response based on that role.
   */
  hasAccess: (role: RoleId) => boolean;

  icon?: JSX.Element; // TODO: Change to SVG element
  hidden?: boolean;
  exact?: boolean;

  /**
   * Force the active state of the navigtion item. Useful when you want to
   * let the user know which context they are in but the URLs do not match
   * 100%.
   *
   * For example in the `manage` app we have a 'Staff' page on `/staff`
   * and a 'your profile' page on `/~/` in the 'Staff' element you could
   * implement `forceActive` like:
   *
   * ```
   * {
   *   title: 'Staff',
   *   path: '/staff',
   *   forceActive: () => window.location.href.indexOf('/~/') > -1,
   * }
   * ```
   */
  forceActive?: () => boolean; // TODO: pass location, etc here
}

export interface AppColor {
  main: string;
  dark: string;
  light: string;
  contrastText: string;
}

export interface AppNavigation {
  title: string;
  path: string;
  icon: JSX.Element;
  hasAccess: (role: RoleId, organizationId?: string) => boolean;
  forceActive?: (location?: string) => boolean;
}

export interface App {
  id: Apps;
  name: string;
  app: React.LazyExoticComponent<() => JSX.Element>;
  navigation: AppNavigation[];
  color: AppColor;
  icon: string;
}

export default undefined;
